import type { PlayerLeague, TeamDetails } from '@pff-consumer/schema'
import { isNfl } from './league'

export const getTeamNameDisplay = (team: TeamDetails, league: PlayerLeague) => {
  if (!team) {
    return null
  }

  if (isNfl(league)) {
    return `${team.abbreviation} ${team.name}`
  }

  if (team.tvAbbreviation) {
    return `${team.tvAbbreviation} ${team.name}`
  }

  return team.city
}
